import { useQuery } from 'react-query';
import {
  getSceneProducts,
  type GetSceneProductsParams,
  type GetSceneProductsResponse
} from '../../services/sceneProductService';
import { SCENE_QUERY_KEYS } from '../queryKeys';

export function useGetSceneProducts(params: GetSceneProductsParams) {
  return useQuery<GetSceneProductsResponse, Error, GetSceneProductsResponse>({
    queryKey: [...SCENE_QUERY_KEYS.sceneProducts, params],
    queryFn: () => getSceneProducts(params),
    refetchOnMount: false
  });
}
